export default __webpack_public_path__ + "static/hero_parent-3fc22f11865ffce7b0adbb1c02f2c6c1.jpg";